import { render } from "./UpdateEmployeesModal.vue?vue&type=template&id=a6411a06&lang=pug"
import script from "./UpdateEmployeesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateEmployeesModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__